<template>
    <div>
        <!-- Show when Customer Record not exists -->
        <not-found
            v-if="!Object.keys(customerDetails).length && !showPageLoader"
        ></not-found>
        <!-- Show when Customer Record not exists -->

        <!-- When data is loading -->
        <base-table-spinner
            v-if="!Object.keys(customerDetails).length && showPageLoader"
        ></base-table-spinner>
        <!-- When data is loading -->

        <div
            v-if="Object.keys(customerDetails).length"
            class="card customer-info screen-section"
        >
            <customer-information
                :customer-details="customerDetails"
            ></customer-information>
        </div>

        <documents-submitted
            v-if="Object.keys(customerDetails).length"
            :document-info="documentInfo"
        ></documents-submitted>

        <div v-if="liveness || face" class="filter-section sub-filter">
            <h2>Verification Status</h2>
        </div>
        <div v-if="liveness || face" class="card customer-info verify-status">
            <ul>
                <li>
                    <div class="seprator-section">
                        <div class="row">
                            <div class="col-md-6">
                                <h3>Liveness Detection</h3>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Verification Timestamp:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span
                                            v-if="
                                                liveness && liveness.createdAt
                                            "
                                        >
                                            {{
                                                liveness.createdAt
                                                    | moment(
                                                        'MMMM D, YYYY hh:mm a'
                                                    )
                                            }}
                                        </span>
                                    </li>
                                </ul>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Score:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span v-if="liveness">
                                            {{ liveness.score }}
                                        </span>
                                    </li>
                                </ul>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Result:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span v-if="liveness">
                                            {{ liveness.result }}
                                        </span>
                                    </li>
                                </ul>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Is Manually Overwritten:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span
                                            v-if="liveness && liveness.isManual"
                                        >
                                            Yes, overwritten by
                                            {{
                                                liveness.overwrittenBy.fullName
                                            }}
                                            on
                                            {{
                                                liveness.overwrittenAt
                                                    | moment('MMMM D, YYYY')
                                            }}
                                        </span>
                                        <span
                                            v-if="
                                                liveness && !liveness.isManual
                                            "
                                        >
                                            No
                                        </span>
                                    </li>
                                    <li
                                        v-if="
                                            hasScopes('manually-overwrite') &&
                                            isAllowedOverwrite
                                        "
                                        class="col-md-6"
                                    >
                                        <label>
                                            <a
                                                href="javascript:void(0)"
                                                class="secondary"
                                                @click="overwrite('liveness')"
                                                >Manually Overwrite Result</a
                                            ></label
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div v-if="face" class="col-md-6">
                                <h3>Face Comparision</h3>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Verification Timestamp:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span v-if="face && face.createdAt">
                                            {{
                                                face.createdAt
                                                    | moment(
                                                        'MMMM D, YYYY hh:mm a'
                                                    )
                                            }}
                                        </span>
                                    </li>
                                </ul>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Score:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span v-if="face">
                                            {{ face.score }}
                                        </span>
                                    </li>
                                </ul>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Result:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span v-if="face">
                                            {{ face.result }}
                                        </span>
                                    </li>
                                </ul>
                                <ul class="row">
                                    <li class="col-md-6">
                                        <label> Is Manually Overwritten:</label>
                                    </li>
                                    <li class="col-md-6">
                                        <span v-if="face && face.isManual">
                                            Yes, overwritten by
                                            {{ face.overwrittenBy.fullName }}
                                            on
                                            {{
                                                face.overwrittenAt
                                                    | moment('MMMM D, YYYY')
                                            }}
                                        </span>
                                        <span v-if="face && !face.isManual">
                                            No
                                        </span>
                                    </li>
                                    <li
                                        v-if="
                                            hasScopes('manually-overwrite') &&
                                            isAllowedOverwrite
                                        "
                                        class="col-md-6"
                                    >
                                        <label>
                                            <a
                                                href="javascript:void(0)"
                                                class="secondary"
                                                @click="overwrite('face')"
                                                >Manually Overwrite Result</a
                                            ></label
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div v-else class="col-md-6">
                                <h3>Face Comparision</h3>
                                <p>
                                    Please wait while face comparison is
                                    processing.....
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <cancel-review-process-popup></cancel-review-process-popup>
        <kyc-status-review-popup></kyc-status-review-popup>
        <overwrite-result-popup
            :verification-type="verificationType"
            :customer-id="id"
            :customer-details="customerDetails"
            @customer="updateCustomer"
        ></overwrite-result-popup>
        <manual-alert-popup></manual-alert-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import customerInformation from '@/components/CustomerInfo.vue'
import documentsSubmitted from '@/components/DocumentsSubmitted.vue'
import kycStatusReviewPopup from '@/components/popups/KYCStatusReviewPopup.vue'
import cancelReviewProcessPopup from '@/components/popups/CancelReviewProcessPopup.vue'
import overwriteResultPopup from '@/components/popups/OverwriteResultPopup.vue'
import manualAlertPopup from '@/components/popups/ManualAlertPopup.vue'
import NotFound from '@/views/404/NotFound.vue'

import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        customerInformation,
        documentsSubmitted,
        kycStatusReviewPopup,
        cancelReviewProcessPopup,
        overwriteResultPopup,
        manualAlertPopup,
        NotFound,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            customerDetails: {},
            verificationType: null,
            showPageLoader: true,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'profile',
            'hasScopes',
            'dataSegmentId',
            'customerRecord',
        ]),

        liveness() {
            return this.customerDetails.verificationStatus &&
                Object.keys(this.customerDetails.verificationStatus.liveness)
                    .length
                ? this.customerDetails.verificationStatus.liveness
                : false
        },

        face() {
            return this.customerDetails.verificationStatus &&
                Object.keys(this.customerDetails.verificationStatus.face).length
                ? this.customerDetails.verificationStatus.face
                : false
        },

        documentInfo() {
            return this.customerDetails.documentInfo
                ? this.customerDetails.documentInfo
                : {}
        },
        isAllowedOverwrite() {
            if (typeof localStorage.getItem('isLeastRole') == 'string') {
                if (localStorage.getItem('isLeastRole') == 'false') {
                    return false
                }
            }

            if (this.customerRecord.nameScreeningStatus != 'updated') {
                return false
            }
            return true
        },
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$router.push({ name: 'view-customer-profile' })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.initializeData()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         *
         * @return {void}
         */
        async initializeData() {
            this.scoreFields = this.profile.kycData.fields

            this.overrideFields = this.profile.kycData.overrideFields

            try {
                let { data } = await request({
                    url: `customers/document-status/${this.id}`,
                })

                this.customerDetails = data.data
            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        }, // End of initializeData() method

        /**
         *
         * @return {void}
         */
        async updateCustomer(customerDetails) {
            this.customerDetails = customerDetails
        }, // End of updateCustomer() method

        /**
         *
         * @return {void}
         */
        overwrite(type) {
            this.verificationType = type
            this.$bvModal.show('overwrite-result-popup')
        }, // End of overwrite() method
    }, // End of Component > watch
} // End of export default
</script>
